module.exports = "<div class=\"container\">\n\n<topnavbar></topnavbar>\n\n\n<imagebanner></imagebanner>\n<div class=\"wrapper\">\n    <navigation></navigation>\n\n<div id=\"content\" style=\"background-color: white;\"   class=\"\n  flex-grow\">\n<router-outlet>\n</router-outlet>\n\n</div>\n\n\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/layouts/basic/basic.component.html
// module id = ./src/app/common/layouts/basic/basic.component.html
// module chunks = main